import React, { useEffect, useMemo, useRef, useState } from "react";
import debounce from "lodash/debounce";

const AdminSearchBox = ({ onSearch }) => {
  const [value, setValue] = useState("");
  const didMountRef = useRef(false);

  const debouncedSearch = useMemo(() => {
    return debounce((v) => {
      onSearch(v.trim());
    }, 500);
  }, [onSearch]);

  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }

    debouncedSearch(value);

    return () => {
      debouncedSearch.cancel();
    };
  }, [value, debouncedSearch]);

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  return (
    <div className="relative mb-6">
      <input
        type="text"
        placeholder="جستجو در سفارشات، شماره سفارش، نام کالا یا مشتری..."
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className="
          w-full rounded-lg border border-gray-300 px-4 py-3 pl-10
          shadow-sm outline-none transition
          focus:border-blue-500 focus:ring-2 focus:ring-blue-500
        "
      />

      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
        <svg
          className="w-5 h-5 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
      </div>
    </div>
  );
};

export default AdminSearchBox;
